var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneClickList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64508 0.667969C9.68087 0.667969 9.71597 0.670982 9.75012 0.676769L9.86417 0.677469C10.0342 0.677469 10.1967 0.746635 10.315 0.869135L14.5358 5.26664C14.6475 5.38247 14.7101 5.5383 14.7101 5.69914V13.3375C14.725 15.4283 13.0967 17.1366 11.0025 17.2216L4.32 17.2225H4.22917C2.18755 17.1763 0.550135 15.5252 0.500252 13.5035L0.5 4.40997C0.548333 2.34247 2.25583 0.677469 4.30833 0.677469L9.54005 0.676769C9.5742 0.670982 9.60929 0.667969 9.64508 0.667969ZM9.02 1.92714L4.31 1.92747C2.92917 1.92747 1.7825 3.0458 1.75 4.42497V13.3375C1.71917 14.765 2.84417 15.9408 4.2575 15.9725H10.9775C12.3683 15.915 13.47 14.7591 13.4601 13.3425L13.46 6.48714L11.7851 6.48797C10.2601 6.4838 9.02008 5.24047 9.02008 3.71714L9.02 1.92714ZM9.48942 11.1747C9.83442 11.1747 10.1144 11.4547 10.1144 11.7997C10.1144 12.1447 9.83442 12.4247 9.48942 12.4247H4.98942C4.64442 12.4247 4.36442 12.1447 4.36442 11.7997C4.36442 11.4547 4.64442 11.1747 4.98942 11.1747H9.48942ZM7.78533 8.04805C8.13033 8.04805 8.41033 8.32805 8.41033 8.67305C8.41033 9.01805 8.13033 9.29805 7.78533 9.29805H4.98867C4.64367 9.29805 4.36367 9.01805 4.36367 8.67305C4.36367 8.32805 4.64367 8.04805 4.98867 8.04805H7.78533ZM10.27 2.62797L10.2701 3.71714C10.2701 4.5538 10.9509 5.23547 11.7867 5.23797L12.775 5.23714L10.27 2.62797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClickList);
export default __webpack_public_path__ + "static/media/oneClickList.b3c36e78c433c67efb57c1af27152e43.svg";
export { ForwardRef as ReactComponent };